import { Button, Card, Grid, IconButton, TextField, Typography } from '@mui/material';
import { any, array, func, number, string } from 'prop-types';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { dispatch } from '../../redux/store';
import { removeAllProjectsEvent } from '../../redux/slices/donation';
import { CloseIcon } from '../../theme/overrides/CustomIcons';
import { setIsGiftCardOpenEvent, setIsGivingBasketOpenEvent } from '../../redux/slices/voucher';

VoucherProjects.propTypes = {
  voucherCode: string,
  project: any,
};

export default function VoucherProjects({ voucherCode, project }) {
  const location = useLocation();
  const navigate = useNavigate();

  const onAddProject = () => {

    try {
      localStorage.setItem('voucherDonationType', 'givingbasket');
    } catch {
      console.error('Failed to store voucher donation type');
    }

    const params = new URLSearchParams(location.search || '');
    params.set('useVoucher', 'true');
    params.set('voucherDonationType', 'givingbasket');
    if (voucherCode) params.set('code', String(voucherCode));
    const nextPathname = '/explore-project';
    const nextSearch = `?${params.toString()}`;
    
    const samePath = location.pathname === nextPathname;
    const sameSearch = location.search === nextSearch;
    
    dispatch(setIsGivingBasketOpenEvent(false));
    if (!samePath || !sameSearch) {
      navigate({ pathname: nextPathname, search: nextSearch }, { replace: false });
    }
  };

  return (
    <>
      {project ? (
        <Grid container direction="column" pt={2}>
          <Grid item>
            <Card sx={{ padding: 3, border: '1px solid #eee' }}>
              <Grid
                container
                spacing={5}
                sx={{ flexDirection: { xs: 'column', md: 'row' }, pt: { xs: 3, md: 0 } }}
                alignItems="stretch"
              >
                <Grid item xs={3} width="100%" maxWidth="unset">
                  <img
                    width="100%"
                    height={200}
                    src={project.mainImage}
                    alt="project-img"
                    style={{ borderRadius: 12, objectFit: 'cover' }}
                  />
                </Grid>
                <Grid item xs={8} container spacing={2} direction="column" justifyContent="center" maxWidth="unset">
                  <Grid item>
                    <Typography variant="h5">{project.name}</Typography>
                    <Typography variant="body2">{project.charityDetails.name}</Typography>
                  </Grid>

                  <Grid item container spacing={1} alignItems="center">
                    <Grid item xs={4}>
                      <Typography>PHP</Typography>
                    </Grid>
                    <Grid item xs={8} position="relative">
                      <TextField
                        disabled
                        value={project.amount}
                        fullWidth
                        inputProps={{
                          sx: { textAlign: 'right', ':disabled': { bgcolor: '#e3e3e3' }, borderRadius: 1 },
                        }}
                        placeholder="0.00"
                      />
                      <img
                        src="/icons/voucher-icon.svg"
                        alt="vi"
                        style={{
                          position: 'absolute',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          marginTop: 5,
                          left: 20,
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <IconButton
                aria-label="close"
                onClick={() => {
                  dispatch(removeAllProjectsEvent());
                }}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            </Card>
          </Grid>
        </Grid>
      ) : (
        <Grid item>
          <Typography variant="h8">Please select at least one (1) project.</Typography>
          <Grid container justifyContent="center" my={3}>
            <Button onClick={onAddProject} variant="contained">
              ADD PROJECT
            </Button>
          </Grid>
        </Grid>
      )}
    </>
  );
}
